// Mock LCA data for development
export const mockLCAData = {
  building: {
    name: 'Sample Office Building',
    type: 'Office',
    area: 1500,
    location: 'Copenhagen, Denmark',
    serviceLife: 50,
    energyUseKwhPerM2Yr: 150
  },
  impactCategories: [
    { id: 'gwp', name: 'Global Warming Potential', unit: 'kg CO2-eq', shortName: 'GWP' },
    { id: 'ap', name: 'Acidification Potential', unit: 'kg SO2-eq', shortName: 'AP' },
    { id: 'ep', name: 'Eutrophication Potential', unit: 'kg PO4-eq', shortName: 'EP' },
    { id: 'odp', name: 'Ozone Depletion Potential', unit: 'kg CFC-11-eq', shortName: 'ODP' }
  ],
  components: [
    {
      id: 1,
      name: 'Foundation',
      category: 'Structure',
      material: 'Concrete',
      quantity: 150,
      unit: 'm³',
      impacts: {
        gwp: 45200,
        ap: 125,
        ep: 45,
        odp: 0.001
      }
    },
    {
      id: 2,
      name: 'Structural Columns',
      category: 'Structure',
      material: 'Steel',
      quantity: 85,
      unit: 'tonnes',
      impacts: {
        gwp: 28900,
        ap: 78,
        ep: 32,
        odp: 0.005
      }
    },
    {
      id: 3,
      name: 'Floor Slabs',
      category: 'Structure',
      material: 'Concrete',
      quantity: 200,
      unit: 'm³',
      impacts: {
        gwp: 60300,
        ap: 167,
        ep: 60,
        odp: 0.002
      }
    },
    {
      id: 4,
      name: 'External Walls',
      category: 'Envelope',
      material: 'Brick',
      quantity: 800,
      unit: 'm²',
      impacts: {
        gwp: 38500,
        ap: 98,
        ep: 38,
        odp: 0.008
      }
    },
    {
      id: 5,
      name: 'Roof Structure',
      category: 'Envelope',
      material: 'Steel',
      quantity: 45,
      unit: 'tonnes',
      impacts: {
        gwp: 22800,
        ap: 75,
        ep: 28,
        odp: 0.006
      }
    },
    {
      id: 6,
      name: 'Windows',
      category: 'Envelope',
      material: 'Glass',
      quantity: 120,
      unit: 'm²',
      impacts: {
        gwp: 18500,
        ap: 45,
        ep: 18,
        odp: 0.003
      }
    },

    {
      id: 7,
      name: 'Wall Insulation',
      category: 'Envelope',
      material: 'Mineral Wool',
      quantity: 800,
      unit: 'm²',
      impacts: {
        gwp: 6800,
        ap: 18,
        ep: 7,
        odp: 0.001
      }
    },
    {
      id: 8,
      name: 'HVAC System',
      category: 'MEP',
      material: 'Steel',
      quantity: 12,
      unit: 'tonnes',
      impacts: {
        gwp: 12400,
        ap: 38,
        ep: 12,
        odp: 0.002
      }
    },
    {
      id: 9,
      name: 'Electrical System',
      category: 'MEP',
      material: 'Copper',
      quantity: 8,
      unit: 'tonnes',
      impacts: {
        gwp: 8900,
        ap: 28,
        ep: 9,
        odp: 0.001
      }
    },
    {
      id: 10,
      name: 'Floor Finishes',
      category: 'Finishes',
      material: 'Ceramic',
      quantity: 500,
      unit: 'm²',
      impacts: {
        gwp: 15600,
        ap: 48,
        ep: 17,
        odp: 0.002
      }
    },
    {
      id: 11,
      name: 'Interior Walls',
      category: 'Finishes',
      material: 'Gypsum',
      quantity: 600,
      unit: 'm²',
      impacts: {
        gwp: 12600,
        ap: 39,
        ep: 13,
        odp: 0.002
      }
    },
    {
      id: 12,
      name: 'Ceiling Finishes',
      category: 'Finishes',
      material: 'Acoustic Panels',
      quantity: 500,
      unit: 'm²',
      impacts: {
        gwp: 9000,
        ap: 20,
        ep: 9,
        odp: 0.002
      }
    },
    {
      id: 13,
      name: 'Paint & Coatings',
      category: 'Finishes',
      material: 'Low-VOC Paint',
      quantity: 1300,
      unit: 'm²',
      impacts: {
        gwp: 9000,
        ap: 11,
        ep: 5,
        odp: 0.001
      }
    }
  ],
  totalImpacts: {
    gwp: 288500,
    ap: 790,
    ep: 293,
    odp: 0.036
  }
};

export const getComponentsByCategory = () => {
  const categories = {};
  mockLCAData.components.forEach(component => {
    if (!categories[component.category]) {
      categories[component.category] = [];
    }
    categories[component.category].push(component);
  });
  return categories;
};

export const getImpactCategoryData = (categoryId) => {
  const category = mockLCAData.impactCategories.find(cat => cat.id === categoryId);
  if (!category) return null;

  const data = mockLCAData.components.map(component => ({
    name: component.name,
    category: component.category,
    value: component.impacts[categoryId] || 0,
    percentage: ((component.impacts[categoryId] || 0) / mockLCAData.totalImpacts[categoryId]) * 100
  }));

  return {
    category,
    data,
    total: mockLCAData.totalImpacts[categoryId]
  };
};
